import {ApplicationConfig} from '@angular/core'
import {provideRouter} from '@angular/router'

import {routes} from './app.routes'
import {registerLocaleData} from '@angular/common'
import localeDe from '@angular/common/locales/de'
import localeDeExtra from '@angular/common/locales/extra/de'
import { provideHttpClient, withXhr } from "@angular/common/http";

registerLocaleData(localeDe, 'de-DE', localeDeExtra)


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withXhr())
  ]
};
